!function (t, n) {
  "object" == typeof exports && "object" == typeof module ? module.exports = n(require("react")) : "function" == typeof define && define.amd ? define("CustomComponents", ["react"], n) : "object" == typeof exports ? exports.CustomComponents = n(require("react")) : t.CustomComponents = n(t.react);
}(this, function (t) {
  return function (t) {
    var n = {};

    function e(r) {
      if (n[r]) return n[r].exports;
      var u = n[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return t[r].call(u.exports, u, u.exports, e), u.l = !0, u.exports;
    }

    return e.m = t, e.c = n, e.d = function (t, n, r) {
      e.o(t, n) || Object.defineProperty(t, n, {
        enumerable: !0,
        get: r
      });
    }, e.r = function (t) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(t, "__esModule", {
        value: !0
      });
    }, e.t = function (t, n) {
      if (1 & n && (t = e(t)), 8 & n) return t;
      if (4 & n && "object" == typeof t && t && t.__esModule) return t;
      var r = Object.create(null);
      if (e.r(r), Object.defineProperty(r, "default", {
        enumerable: !0,
        value: t
      }), 2 & n && "string" != typeof t) for (var u in t) {
        e.d(r, u, function (n) {
          return t[n];
        }.bind(null, u));
      }
      return r;
    }, e.n = function (t) {
      var n = t && t.__esModule ? function () {
        return t.default;
      } : function () {
        return t;
      };
      return e.d(n, "a", n), n;
    }, e.o = function (t, n) {
      return Object.prototype.hasOwnProperty.call(t, n);
    }, e.p = "dist", e(e.s = 4);
  }([function (n, e) {
    n.exports = t;
  }, function (t, n, e) {
    "use strict";

    t.exports = e(2);
  }, function (t, n, e) {
    "use strict";
    /** @license React v17.0.1
     * react-jsx-runtime.production.min.js
     *
     * Copyright (c) Facebook, Inc. and its affiliates.
     *
     * This source code is licensed under the MIT license found in the
     * LICENSE file in the root directory of this source tree.
     */

    e(3);
    var r = e(0),
        u = 60103;

    if (n.Fragment = 60107, "function" == typeof Symbol && Symbol.for) {
      var a = Symbol.for;
      u = a("react.element"), n.Fragment = a("react.fragment");
    }

    var o = r.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,
        i = Object.prototype.hasOwnProperty,
        c = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    };

    function m(t, n, e) {
      var r,
          a = {},
          m = null,
          f = null;

      for (r in void 0 !== e && (m = "" + e), void 0 !== n.key && (m = "" + n.key), void 0 !== n.ref && (f = n.ref), n) {
        i.call(n, r) && !c.hasOwnProperty(r) && (a[r] = n[r]);
      }

      if (t && t.defaultProps) for (r in n = t.defaultProps) {
        void 0 === a[r] && (a[r] = n[r]);
      }
      return {
        $$typeof: u,
        type: t,
        key: m,
        ref: f,
        props: a,
        _owner: o.current
      };
    }

    n.jsx = m, n.jsxs = m;
  }, function (t, n, e) {
    "use strict";
    /*
    object-assign
    (c) Sindre Sorhus
    @license MIT
    */

    var r = Object.getOwnPropertySymbols,
        u = Object.prototype.hasOwnProperty,
        a = Object.prototype.propertyIsEnumerable;

    function o(t) {
      if (null == t) throw new TypeError("Object.assign cannot be called with null or undefined");
      return Object(t);
    }

    t.exports = function () {
      try {
        if (!Object.assign) return !1;
        var t = new String("abc");
        if (t[5] = "de", "5" === Object.getOwnPropertyNames(t)[0]) return !1;

        for (var n = {}, e = 0; e < 10; e++) {
          n["_" + String.fromCharCode(e)] = e;
        }

        if ("0123456789" !== Object.getOwnPropertyNames(n).map(function (t) {
          return n[t];
        }).join("")) return !1;
        var r = {};
        return "abcdefghijklmnopqrst".split("").forEach(function (t) {
          r[t] = t;
        }), "abcdefghijklmnopqrst" === Object.keys(Object.assign({}, r)).join("");
      } catch (t) {
        return !1;
      }
    }() ? Object.assign : function (t, n) {
      for (var e, i, c = o(t), m = 1; m < arguments.length; m++) {
        for (var f in e = Object(arguments[m])) {
          u.call(e, f) && (c[f] = e[f]);
        }

        if (r) {
          i = r(e);

          for (var g = 0; g < i.length; g++) {
            a.call(e, i[g]) && (c[i[g]] = e[i[g]]);
          }
        }
      }

      return c;
    };
  }, function (t, n, e) {
    "use strict";

    e.r(n);

    var r = e(1),
        u = e(0),
        _a = function a() {
      return (_a = Object.assign || function (t) {
        for (var n, e = 1, r = arguments.length; e < r; e++) {
          for (var u in n = arguments[e]) {
            Object.prototype.hasOwnProperty.call(n, u) && (t[u] = n[u]);
          }
        }

        return t;
      }).apply(this, arguments);
    },
        o = function o(t) {
      var n = Object(u.useState)(t.show),
          e = n[0],
          o = n[1],
          c = Object(u.useState)(t),
          m = c[0],
          f = c[1],
          g = Object(u.useState)(""),
          s = g[0],
          l = g[1],
          d = Object(u.useState)(""),
          N = d[0],
          p = d[1],
          b = Object(u.useState)(null),
          y = b[0],
          h = b[1],
          v = t.tagName;
      Object(u.useEffect)(function () {
        if ("undefined" != typeof document) {
          var t = document.styleSheets[0];
          t || (t = document.createElement("style"), document.head.appendChild(t)), h(document.styleSheets[0]);
        }
      }, []), Object(u.useEffect)(function () {
        if (y) {
          if (t.mountAnimId) l(t.mountAnimId);else {
            var n = "mount-" + i(8),
                e = "@-webkit-keyframes " + n + " {\n          " + t.mountAnim + "\n      }\n      ";
            y.insertRule(e, y.cssRules ? y.cssRules.length : 0), l(n);
          }
          if (t.unmountAnimId) p(t.unmountAnimId);else {
            var r = "mount-" + i(8);
            e = "@-webkit-keyframes " + r + " {\n        " + (t.unmountAnim ? t.unmountAnim : t.mountAnim) + "\n      }\n      ";
            y.insertRule(e, y.cssRules ? y.cssRules.length : 0), p(r);
          }

          var u = _a({}, t);

          delete u.tagName, delete u.mountAnim, delete u.unmountAnim, delete u.mountAnimId, delete u.unmountAnimId, delete u.show, delete u.time, delete u.unmountTime, delete u.delay, delete u.unmountDelay, delete u.onMountEnd, delete u.onUnmountEnd, f(u);
        }
      }, [y, t.mountAnim, t.unmountAnim, t.mountAnimId, t.unmountAnimId]), Object(u.useEffect)(function () {
        t.show && (t.delay ? setTimeout(function () {
          o(!0);
        }, 1e3 * t.delay) : o(!0));
      }, [t.show, t.delay]);
      return e && Object(r.jsx)(v, _a({}, m, {
        style: _a({
          animationName: "" + (t.show ? s : N),
          animationDuration: (void 0 === t.unmountTime || t.show ? t.time ? t.time : 1 : t.unmountTime) + "s",
          animationDirection: t.show || t.unmountAnim || t.unmountAnimId ? "normal" : "reverse",
          animationDelay: (void 0 === t.unmountDelay || t.show ? 0 : t.unmountDelay) + "s"
        }, t.style),
        onAnimationEnd: function onAnimationEnd() {
          t.show || o(!1), t.onMountEnd && t.show && t.onMountEnd(), t.onUnmountEnd && !t.show && t.onUnmountEnd(), t.onAnimationEnd && t.onAnimationEnd();
        }
      }, {
        children: t.children
      }), void 0);
    };

    function i(t) {
      for (var n = "", e = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789", r = e.length, u = 0; u < t; u++) {
        n += e.charAt(Math.floor(Math.random() * r));
      }

      return n;
    }

    var c = {
      a: function a(t) {
        return o(_a({
          tagName: "a"
        }, t));
      },
      abbr: function abbr(t) {
        return o(_a({
          tagName: "abbr"
        }, t));
      },
      address: function address(t) {
        return o(_a({
          tagName: "address"
        }, t));
      },
      area: function area(t) {
        return o(_a({
          tagName: "area"
        }, t));
      },
      article: function article(t) {
        return o(_a({
          tagName: "article"
        }, t));
      },
      aside: function aside(t) {
        return o(_a({
          tagName: "aside"
        }, t));
      },
      audio: function audio(t) {
        return o(_a({
          tagName: "audio"
        }, t));
      },
      b: function b(t) {
        return o(_a({
          tagName: "b"
        }, t));
      },
      base: function base(t) {
        return o(_a({
          tagName: "base"
        }, t));
      },
      bdi: function bdi(t) {
        return o(_a({
          tagName: "bdi"
        }, t));
      },
      bdo: function bdo(t) {
        return o(_a({
          tagName: "bdo"
        }, t));
      },
      big: function big(t) {
        return o(_a({
          tagName: "big"
        }, t));
      },
      blockquote: function blockquote(t) {
        return o(_a({
          tagName: "blockquote"
        }, t));
      },
      body: function body(t) {
        return o(_a({
          tagName: "body"
        }, t));
      },
      br: function br(t) {
        return o(_a({
          tagName: "br"
        }, t));
      },
      button: function button(t) {
        return o(_a({
          tagName: "button"
        }, t));
      },
      canvas: function canvas(t) {
        return o(_a({
          tagName: "canvas"
        }, t));
      },
      caption: function caption(t) {
        return o(_a({
          tagName: "caption"
        }, t));
      },
      cite: function cite(t) {
        return o(_a({
          tagName: "cite"
        }, t));
      },
      code: function code(t) {
        return o(_a({
          tagName: "code"
        }, t));
      },
      col: function col(t) {
        return o(_a({
          tagName: "col"
        }, t));
      },
      colgroup: function colgroup(t) {
        return o(_a({
          tagName: "colgroup"
        }, t));
      },
      data: function data(t) {
        return o(_a({
          tagName: "data"
        }, t));
      },
      datalist: function datalist(t) {
        return o(_a({
          tagName: "datalist"
        }, t));
      },
      dd: function dd(t) {
        return o(_a({
          tagName: "dd"
        }, t));
      },
      del: function del(t) {
        return o(_a({
          tagName: "del"
        }, t));
      },
      details: function details(t) {
        return o(_a({
          tagName: "details"
        }, t));
      },
      dfn: function dfn(t) {
        return o(_a({
          tagName: "dfn"
        }, t));
      },
      dialog: function dialog(t) {
        return o(_a({
          tagName: "dialog"
        }, t));
      },
      div: function div(t) {
        return o(_a({
          tagName: "div"
        }, t));
      },
      dl: function dl(t) {
        return o(_a({
          tagName: "dl"
        }, t));
      },
      dt: function dt(t) {
        return o(_a({
          tagName: "dt"
        }, t));
      },
      em: function em(t) {
        return o(_a({
          tagName: "em"
        }, t));
      },
      embed: function embed(t) {
        return o(_a({
          tagName: "embed"
        }, t));
      },
      fieldset: function fieldset(t) {
        return o(_a({
          tagName: "fieldset"
        }, t));
      },
      figcaption: function figcaption(t) {
        return o(_a({
          tagName: "figcaption"
        }, t));
      },
      figure: function figure(t) {
        return o(_a({
          tagName: "figure"
        }, t));
      },
      footer: function footer(t) {
        return o(_a({
          tagName: "footer"
        }, t));
      },
      form: function form(t) {
        return o(_a({
          tagName: "form"
        }, t));
      },
      h1: function h1(t) {
        return o(_a({
          tagName: "h1"
        }, t));
      },
      h2: function h2(t) {
        return o(_a({
          tagName: "h2"
        }, t));
      },
      h3: function h3(t) {
        return o(_a({
          tagName: "h3"
        }, t));
      },
      h4: function h4(t) {
        return o(_a({
          tagName: "h4"
        }, t));
      },
      h5: function h5(t) {
        return o(_a({
          tagName: "h5"
        }, t));
      },
      h6: function h6(t) {
        return o(_a({
          tagName: "h6"
        }, t));
      },
      head: function head(t) {
        return o(_a({
          tagName: "head"
        }, t));
      },
      header: function header(t) {
        return o(_a({
          tagName: "header"
        }, t));
      },
      hgroup: function hgroup(t) {
        return o(_a({
          tagName: "hgroup"
        }, t));
      },
      hr: function hr(t) {
        return o(_a({
          tagName: "hr"
        }, t));
      },
      html: function html(t) {
        return o(_a({
          tagName: "html"
        }, t));
      },
      i: function i(t) {
        return o(_a({
          tagName: "i"
        }, t));
      },
      iframe: function iframe(t) {
        return o(_a({
          tagName: "iframe"
        }, t));
      },
      img: function img(t) {
        return o(_a({
          tagName: "img"
        }, t));
      },
      input: function input(t) {
        return o(_a({
          tagName: "input"
        }, t));
      },
      ins: function ins(t) {
        return o(_a({
          tagName: "ins"
        }, t));
      },
      kbd: function kbd(t) {
        return o(_a({
          tagName: "kbd"
        }, t));
      },
      keygen: function keygen(t) {
        return o(_a({
          tagName: "keygen"
        }, t));
      },
      label: function label(t) {
        return o(_a({
          tagName: "label"
        }, t));
      },
      legend: function legend(t) {
        return o(_a({
          tagName: "legend"
        }, t));
      },
      li: function li(t) {
        return o(_a({
          tagName: "li"
        }, t));
      },
      link: function link(t) {
        return o(_a({
          tagName: "link"
        }, t));
      },
      main: function main(t) {
        return o(_a({
          tagName: "main"
        }, t));
      },
      map: function map(t) {
        return o(_a({
          tagName: "map"
        }, t));
      },
      mark: function mark(t) {
        return o(_a({
          tagName: "mark"
        }, t));
      },
      menu: function menu(t) {
        return o(_a({
          tagName: "menu"
        }, t));
      },
      menuitem: function menuitem(t) {
        return o(_a({
          tagName: "menuitem"
        }, t));
      },
      meta: function meta(t) {
        return o(_a({
          tagName: "meta"
        }, t));
      },
      meter: function meter(t) {
        return o(_a({
          tagName: "meter"
        }, t));
      },
      nav: function nav(t) {
        return o(_a({
          tagName: "nav"
        }, t));
      },
      noindex: function noindex(t) {
        return o(_a({
          tagName: "noindex"
        }, t));
      },
      noscript: function noscript(t) {
        return o(_a({
          tagName: "noscript"
        }, t));
      },
      object: function object(t) {
        return o(_a({
          tagName: "object"
        }, t));
      },
      ol: function ol(t) {
        return o(_a({
          tagName: "ol"
        }, t));
      },
      optgroup: function optgroup(t) {
        return o(_a({
          tagName: "optgroup"
        }, t));
      },
      option: function option(t) {
        return o(_a({
          tagName: "option"
        }, t));
      },
      output: function output(t) {
        return o(_a({
          tagName: "output"
        }, t));
      },
      p: function p(t) {
        return o(_a({
          tagName: "p"
        }, t));
      },
      param: function param(t) {
        return o(_a({
          tagName: "param"
        }, t));
      },
      picture: function picture(t) {
        return o(_a({
          tagName: "picture"
        }, t));
      },
      pre: function pre(t) {
        return o(_a({
          tagName: "pre"
        }, t));
      },
      progress: function progress(t) {
        return o(_a({
          tagName: "progress"
        }, t));
      },
      q: function q(t) {
        return o(_a({
          tagName: "q"
        }, t));
      },
      rp: function rp(t) {
        return o(_a({
          tagName: "rp"
        }, t));
      },
      rt: function rt(t) {
        return o(_a({
          tagName: "rt"
        }, t));
      },
      ruby: function ruby(t) {
        return o(_a({
          tagName: "ruby"
        }, t));
      },
      s: function s(t) {
        return o(_a({
          tagName: "s"
        }, t));
      },
      samp: function samp(t) {
        return o(_a({
          tagName: "samp"
        }, t));
      },
      slot: function slot(t) {
        return o(_a({
          tagName: "slot"
        }, t));
      },
      script: function script(t) {
        return o(_a({
          tagName: "script"
        }, t));
      },
      section: function section(t) {
        return o(_a({
          tagName: "section"
        }, t));
      },
      select: function select(t) {
        return o(_a({
          tagName: "select"
        }, t));
      },
      small: function small(t) {
        return o(_a({
          tagName: "small"
        }, t));
      },
      source: function source(t) {
        return o(_a({
          tagName: "source"
        }, t));
      },
      span: function span(t) {
        return o(_a({
          tagName: "span"
        }, t));
      },
      strong: function strong(t) {
        return o(_a({
          tagName: "strong"
        }, t));
      },
      style: function style(t) {
        return o(_a({
          tagName: "style"
        }, t));
      },
      sub: function sub(t) {
        return o(_a({
          tagName: "sub"
        }, t));
      },
      summary: function summary(t) {
        return o(_a({
          tagName: "summary"
        }, t));
      },
      sup: function sup(t) {
        return o(_a({
          tagName: "sup"
        }, t));
      },
      table: function table(t) {
        return o(_a({
          tagName: "table"
        }, t));
      },
      template: function template(t) {
        return o(_a({
          tagName: "template"
        }, t));
      },
      tbody: function tbody(t) {
        return o(_a({
          tagName: "tbody"
        }, t));
      },
      td: function td(t) {
        return o(_a({
          tagName: "td"
        }, t));
      },
      textarea: function textarea(t) {
        return o(_a({
          tagName: "textarea"
        }, t));
      },
      tfoot: function tfoot(t) {
        return o(_a({
          tagName: "tfoot"
        }, t));
      },
      th: function th(t) {
        return o(_a({
          tagName: "th"
        }, t));
      },
      thead: function thead(t) {
        return o(_a({
          tagName: "thead"
        }, t));
      },
      time: function time(t) {
        return o(_a({
          tagName: "time"
        }, t));
      },
      title: function title(t) {
        return o(_a({
          tagName: "title"
        }, t));
      },
      tr: function tr(t) {
        return o(_a({
          tagName: "tr"
        }, t));
      },
      track: function track(t) {
        return o(_a({
          tagName: "track"
        }, t));
      },
      u: function u(t) {
        return o(_a({
          tagName: "u"
        }, t));
      },
      ul: function ul(t) {
        return o(_a({
          tagName: "ul"
        }, t));
      },
      var: function _var(t) {
        return o(_a({
          tagName: "var"
        }, t));
      },
      video: function video(t) {
        return o(_a({
          tagName: "video"
        }, t));
      },
      wbr: function wbr(t) {
        return o(_a({
          tagName: "wbr"
        }, t));
      },
      webview: function webview(t) {
        return o(_a({
          tagName: "webview"
        }, t));
      }
    };
    n.default = c;
  }]);
});